import { ReportCardVariant } from '../display/reportCard/types';
import { ReportGridGroup, ReportGridItem, ReportYamlGroup, ReportYamlItem } from '../types/report';

export const transformGroups = (groups: ReportYamlGroup[]): ReportGridGroup[] => {
  return groups.map((group: any) => {
    return {
      description: group.description,
      items: group.widgets?.map(transformWidget) || [],
      title: group.title,
    };
  });
};

export const transformWidget = (widget: ReportYamlItem): ReportGridItem => {
  const widgetWidth = widget.display?.width || widget.width;

  return {
    baseQuery: widget.query ?? '',
    display: {
      ...(widgetWidth && {
        widths: {
          maxWidth: widgetWidth,
        },
      }),
      visualization: {
        ...widget.display,
        ...(widget.queries && {
          queries: widget.queries.map((query: any) => ({
            baseQuery: query.query,
            title: query.title,
          })),
        }),
      } as unknown as ReportCardVariant,
    },
    params: {},
    title: widget.title,
  };
};
